import React from "react";
import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, y = 30, className = "" }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const SectionHeading = ({ overline, title, text, center = false }) => (
  <div className={`max-w-3xl ${center ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <div className={`flex items-center gap-4 ${center ? "justify-center" : ""}`}>
        <span className="overline" data-testid="section-overline">{overline}</span>
      </div>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className="mt-5 text-3xl sm:text-4xl lg:text-5xl font-light tracking-tight text-[#FFFFF0] leading-[1.1]">
        {title}
      </h2>
    </Reveal>
    {text && (
      <Reveal delay={0.16}>
        <p className="mt-6 text-base leading-relaxed text-[#FFFFF0]/70 font-light">{text}</p>
      </Reveal>
    )}
  </div>
);
